export type DomainVariant = 'light' | 'main' | 'medium' | 'dark' | 'veryLight';

export interface DomainColorSet {
  light?: string;
  main: string;
  medium?: string;
  dark?: string;
  veryLight?: string;
}

export type DomainCode = 'ST' | 'M' | 'MD' | 'ACC' | 'SONG' | 'EX' | string;

const domainColors: Record<string, DomainColorSet> = {
  ST: { light: '#80ade6', main: '#2c76d5', medium: 'rgb(128,173,230)', dark: '#1d5195' },
  M: { light: '#fcc79a', main: 'rgb(248, 114, 3)', medium: '#fbaa68', veryLight: '#fbd788' },
  MD: { light: 'rgb(237,176,213)', main: 'rgb(211, 58, 150)', medium: 'rgb(229,137,192)' },
  ACC: { light: 'rgb(163,205,161)', main: 'rgb(26, 131, 20)', medium: 'rgb(118,181,114)' },
  SONG: { light: '#c2b6de', main: '#6748ac', medium: '#a491cd', dark: '#483278' },
  EX: { light: '#b1b1b180', main: '#898989', veryLight: '#b1b1b180', dark: '#3b3b3b' },
};

const defaultColors: DomainColorSet = {
  light: '#b1b1b180',
  main: '#898989',
  dark: '#3b3b3b',
};

export const getDomainColor = (domain: DomainCode, variant: DomainVariant = 'main'): string => {
  const colors = domainColors[domain] || defaultColors;
  return (colors[variant as keyof DomainColorSet] as string) || colors.main;
};

export const getDomainColorLight = (domain: DomainCode): string => getDomainColor(domain, 'light');
